import { useEffect, useReducer } from 'react';
import defaultReducer from '../store/componentReducer';
import { init } from '../store/actions';

const useComponent = ({ components, id, initialState = {}, reducer = defaultReducer, setComponents }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { data } = state;

  const componentIndex = components.findIndex(obj => obj.id === id);
  const { component } = components[componentIndex];

  useEffect(() => {
    const updatedComponent = {
      id,
      component: data,
    };
    setComponents(updatedComponent, componentIndex);
  }, [data]);

  useEffect(() => {
    if (component) init(dispatch)(component);
  }, []);

  return { state, dispatch, componentIndex };
};


export default useComponent;
